import { Injectable } from '@angular/core';
import { QueryEntity } from '@datorama/akita';
import { compareEntities } from '@lycoris-nubila/ngx-lycoris';
import { isNil, reject, uniqBy } from 'lodash-es';
import { Observable } from 'rxjs';
import { distinctUntilChanged, map, shareReplay } from 'rxjs/operators';

import { Article } from 'article/article';
import { ArticleRepositoryPort } from 'article/port/article-repository.port';

import { CacheObservable } from '../../app-decorators';
import { ArticleState, ArticleStore } from './article.store';

@Injectable()
export class ArticleRepositoryAdapter
	extends QueryEntity<ArticleState>
	implements ArticleRepositoryPort
{
	constructor(protected store: ArticleStore) {
		super(store);
	}

	@CacheObservable()
	public observeArticlesByIds(ids: string[]): Observable<Article[]> {
		return this.selectAll({
			sortBy: (a, b) => ids.indexOf(a.id) - ids.indexOf(b.id),
			filterBy: (entity) => (ids || []).includes(entity.id),
		}).pipe(
			map((documents) =>
				documents.map((document) => this.store.asEntity(document))
			),
			distinctUntilChanged(compareEntities),
			shareReplay({ bufferSize: 1, refCount: true })
		);
	}

	public async saveArticles(entities: Article[]): Promise<void> {
		this.store.upsertMany(
			uniqBy(
				reject(entities, isNil).map((e) => this.store.asDocument(e)),
				'id'
			)
		);
	}
}
